import React from 'react';
import Helmet from 'react-helmet';
import { withRouter, Link } from 'react-router-dom';

import { Consumer } from '../context';
import AppLinks from '../components/AppLinks';
import { login, activate } from '../api/v1/auth';
import Logo from '../images/logo.png';

class Login extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         errorPass: false,
         errorMessage: '',
      };
   }

   async login(e) {
      e.preventDefault();
      this.setState({ loading: true, errorPass: false });
      const form = e.target;
      const res = await login(form.usuario.value || '', form.password.value || '');
      if (res.ok) {
         this.finish();
         return;
      }
      if (res.appOnly) {
         this.setState({ appOnly: true, loading: false });
         return;
      }
      if (res.activationToken) {
         // La cuenta sigue con la contraseña de alta: hay que fijar una nueva.
         this.setState({ activationToken: res.activationToken, loading: false });
         return;
      }
      this.setState({ errorPass: true, errorMessage: res.message, loading: false });
   }

   async activate(e) {
      e.preventDefault();
      const form = e.target;
      const password = form.newPassword.value || '';
      if (password.length < 8) {
         this.setState({ errorPass: true, errorMessage: 'La contraseña debe tener al menos 8 caracteres.' });
         return;
      }
      if (password !== form.confirmPassword.value) {
         this.setState({ errorPass: true, errorMessage: 'Las contraseñas no coinciden.' });
         return;
      }
      this.setState({ loading: true, errorPass: false });
      const res = await activate(this.state.activationToken, password);
      if (res.ok) {
         this.finish();
         return;
      }
      this.setState({
         errorPass: true,
         errorMessage: res.message || 'No se pudo guardar la contraseña. Inicia sesión de nuevo.',
         loading: false,
      });
   }

   finish() {
      this.props.context.loginSuccess();
      this.props.context.getUser();
      this.props.history.push('/');
   }

   renderActivation() {
      return (
         <form
            className="column full "
            onSubmit={(event) => {
               this.activate(event);
            }}>
            <div className="white-space-16" />
            <p className="text-center color-white">
               Es tu primer inicio de sesión. Crea una contraseña nueva de al menos 8 caracteres.
            </p>
            {[
               ['newPassword', 'Contraseña nueva'],
               ['confirmPassword', 'Confirmar contraseña'],
            ].map(([name, label]) => (
               <React.Fragment key={name}>
                  <div className="white-space-16" />
                  <div className="row full btn-container justify-center">
                     <span className="label-login color-white weight-medium">{label}:</span>
                  </div>
                  <div className="row full input-container ">
                     <div className="column full justify-center align-center">
                        <input
                           name={name}
                           type="password"
                           minLength="8"
                           maxLength="72"
                           autoComplete="new-password"
                           placeholder={label}
                           className="weight-semi text-center"
                           required
                        />
                     </div>
                  </div>
               </React.Fragment>
            ))}
            <div className="white-space-32" />
            <div className="row full btn-container justify-center">
               <button type="submit" className="btn btn-primary color-white">
                  {this.state.loading ? (
                     <i className="fas fa-spinner fa-spin font-text" />
                  ) : (
                     <span className="color-white">GUARDAR Y ENTRAR</span>
                  )}
               </button>
            </div>
            {this.renderError()}
         </form>
      );
   }

   // Cuenta de propietario o invitado: el portal es del equipo, así que se le
   // manda a la app como hacía el portal anterior.
   renderAppOnly() {
      return (
         <div className="column full">
            <div className="white-space-16" />
            <p className="text-center color-white">
               Tu cuenta es de la app de Eleva. Continúa en la app para dar seguimiento a tus reportes.
            </p>
            <div className="white-space-24" />
            <AppLinks />
            <div className="white-space-32" />
            <div className="row full btn-container justify-center">
               <button
                  type="button"
                  className="btn btn-primary color-white"
                  onClick={() => this.setState({ appOnly: false })}>
                  <span className="color-white">ENTRAR CON OTRA CUENTA</span>
               </button>
            </div>
         </div>
      );
   }

   renderError() {
      return this.state.errorPass ? (
         <React.Fragment>
            <div className="white-space-16" />
            <div className="column error-login">
               <div className="white-space-8" />
               <p className="text-center color-white">{this.state.errorMessage}</p>
               <div className="white-space-8" />
            </div>
         </React.Fragment>
      ) : null;
   }

   render() {
      return (
         <div className="login column align-center">
            <Helmet>
               <title>ELEVA Capital Group | Login </title>
            </Helmet>
            <div className="justify-center content">
               <div className="full align-center justify-center">
                  <div className="column full colum-space">
                     <div className="white-space-8"></div>
                  </div>
                  <div className="column full justify-center align-center card-login">
                     <div className="responsive-img justify-center">
                        <img src={Logo} alt={`Logo ELEVA`} title={`Logo ELEVA`} />
                     </div>
                     <div className="white-space-16" />
                     <h3 className="text-center color-white">
                        {this.state.appOnly ? 'Continúa en la app' : 'Iniciar sesión'}
                     </h3>
                     <div className="white-space-16" />
                     {this.state.appOnly && this.renderAppOnly()}
                     {!this.state.appOnly && (this.state.activationToken ? this.renderActivation() : (
                     <form
                        className="column full "
                        onSubmit={(event) => {
                           this.login(event);
                        }}>
                        <div className="white-space-16" />
                        <div className="row full btn-container justify-center">
                           <span className="label-login color-white weight-medium">
                              Correo:
                           </span>
                        </div>
                        <div className="row full input-container ">
                           <div className="column full justify-center align-center">
                              <input
                                 name="usuario"
                                 type="email"
                                 maxLength="200"
                                 autoComplete="username"
                                 placeholder="correo@ejemplo.com"
                                 className="weight-semi text-center"
                                 required
                              />
                           </div>
                        </div>

                        <div className="white-space-16" />
                        <div className="row full btn-container justify-center">
                           <span className="label-login color-white weight-medium">
                              Contraseña:
                           </span>
                        </div>
                        <div className="row full input-container ">
                           <div className="column full justify-center align-center">
                              <input
                                 name="password"
                                 type="password"
                                 maxLength="64"
                                 autoComplete="off"
                                 placeholder="Contraseña"
                                 className="weight-semi text-center"
                                 required
                              />
                           </div>
                        </div>

                        <div className="white-space-8" />

                        <div className="white-space-32" />
                        <div className="row full btn-container justify-center">
                           <button type="submit" className="btn btn-primary color-white">
                              {this.state.loading ? (
                                 <i className="fas fa-spinner fa-spin font-text" />
                              ) : (
                                 <span className="color-white">
                                    <i className="fas fa-sign-in-alt font-text" />
                                    &nbsp; ACCEDER
                                 </span>
                              )}
                           </button>
                        </div>
                        <div className="white-space-16"></div>
                        <div className="row full justify-center align-center">
                           <Link to="/recover" className="color-white">
                              Recuperar Contraseña
                           </Link>
                        </div>
                        {this.state.errorPass ? (
                           <React.Fragment>
                              <div className="white-space-16" />
                              <div className="column error-login">
                                 <div className="white-space-8" />
                                 <p className="text-center color-white">
                                    {this.state.errorMessage}
                                 </p>
                                 <div className="white-space-8" />
                              </div>
                           </React.Fragment>
                        ) : null}
                        <div className="white-space-64" />
                        <div className="white-space-64" />
                     </form>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      );
   }
}
export default withRouter(Consumer(Login));
